var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex",class:_vm.$attrs.class},[_c('p',{staticClass:"lg:text-3xl text-2xl font-thin"}),_c('b',{staticClass:"lg:text-6xl text-4xl w-2/3"},[_vm._v(" "+_vm._s(_vm.$attrs.result)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }